






import './audioplayer.css'
import React from 'react'
import { clamp } from '../helpers'

const DEMOS =
    [ './audio/tech.wav'
    , './audio/nice.wav'
    , './audio/ethereal.wav'
    , './audio/groovyman.wav'
    ]

const DEMO_NAMES = DEMOS.map(s => s.split('/')[2].split('.')[0])
const globalAudio = new Audio(DEMOS[0])

export class AudioPlayer extends React.Component {

    constructor(props) {
        super(props)    

        this.timeRemaining = React.createRef();
        this.timeline = React.createRef();
        this.playBtn = React.createRef()
        this.volumeSlider = React.createRef()
        this.progress = React.createRef()
        this.name = React.createRef()
        // this.volumeEl = React.createRef()
        this.audioPlayer = React.createRef()
        this.demoIndex = 0

        this.audio = globalAudio // This prevents multiple audio from playing
        this.audio.loop = true
        
        this.hasRenderedOnce = false
    }

    show() {
        this.audioPlayer.current.classList.add('show')
    }
    hide() {
        this.audioPlayer.current.classList.remove('show')
    }
    togglePlay() {
        const icon = this.playBtn.current.children[0]
        if (this.audio.paused) 
        {
            icon.classList.remove("icono-play")
            icon.classList.add("icono-pause")
            this.audio.play()
        } 
        else
        {
            icon.classList.remove("icono-pause")
            icon.classList.add("icono-play")
            this.audio.pause()
        }
    }
    turnOff() {
        if (this.audio.paused) return;
        this.togglePlay()
    }

    render() { 
        // const changeVolume = onclick => e => {
        //     if (!onclick && e.buttons !== 1) return;
        //     const sliderWidth = this.volumeSlider.current.getBoundingClientRect().width
        //     const newVolume = clamp(0, e.nativeEvent.offsetX / parseInt(sliderWidth), 1);
        //     this.audio.volume = newVolume;
        //     this.volumeSlider.current.children[0].style.width = newVolume * 100 + '%';
        // }

        const drawProgressBar = () => {
            if (!this.progress.current) return; // Wait for it to "load" or something.
            const progressBar = this.progress.current
            progressBar.style.width = 
                this.audio.currentTime / this.audio.duration * 100 + "%"
            this.timeRemaining.current.textContent = getTimeCodeFromNum(
                this.audio.duration - this.audio.currentTime)
        }

        const changeDemo = direction => () => { 
            this.demoIndex = clamp(0, this.demoIndex + direction, DEMOS.length-1)
            const isPlaying = !this.audio.paused
            this.audio.src = DEMOS[this.demoIndex]
            if (isPlaying) this.audio.play()
            this.audio.loop = true
            this.name.current.textContent = 
                `${DEMO_NAMES[this.demoIndex]} ${this.demoIndex+1}/4`
        }

        this.audio.ondurationchange = () => {
            if (this.timeRemaining.current == null) return;
            this.timeRemaining.current.textContent = 
                getTimeCodeFromNum(this.audio.duration)
        }
        
        //! TODO: clean this:
        setTimeout(() => {
        this.audio.volume = 1 // .5
        this.name.current.textContent = 
            `${DEMO_NAMES[this.demoIndex]} ${this.demoIndex+1}/4`
        }, 20)

        setInterval(drawProgressBar, 500)
        
        this.hasRenderedOnce = true
        return <div ref={this.audioPlayer} className="audio-player">
            <div ref={this.timeline} className="timeline" onClick={
                e => {
                    const timelineWidth = this.timeline.current.getBoundingClientRect().width
                    const timeToSeek
                        = e.nativeEvent.offsetX 
                        / parseInt(timelineWidth) * this.audio.duration
                    this.audio.currentTime = timeToSeek;
                    drawProgressBar()
                }}>
                <div ref={this.progress} className="progress"/>
            </div>
            <div className="controls">
                <div className="play-container">
                    <div className="icono-rewind icon0" onClick={changeDemo(-1)}/>
                    <div ref={this.playBtn} className="toggle-play" onClick={() => this.togglePlay()}>
                        <div className="play icono-play"/>
                    </div>
                    <div className="icono-forward icon1" onClick={changeDemo(1)}/>
                </div>

                <div ref={this.timeRemaining} className="length">NaN</div>

                <div ref={this.name} className="name"/>

                {/* <div className="volume-container">
                    <div className="volume-button" onClick={
                        () => {
                            console.log(this.volumeE)
                            const volumeEl = this.volumeEl.current
                            this.audio.muted = !this.audio.muted;
                            volumeEl.classList.toggle("icono-volumeHigh", !this.audio.muted);
                            volumeEl.classList.toggle("icono-volumeMute", this.audio.muted);
                        }
                        }>
                        <div ref={this.volumeEl} className="volume icono-volumeHigh"></div>
                    </div>
                
                    <div ref={this.volumeSlider} className="volume-slider" onMouseMove={changeVolume(false)} onClick={changeVolume(true)}>
                        <div className="volume-percentage"></div>
                    </div>
                </div> */}

                <div className="close icono-cross" onClick={() => (this.hide(), this.turnOff())}/>
            </div>
        </div>

    }
}

// //turn 128 seconds into 2:08
function getTimeCodeFromNum(num) {
    if (Number.isNaN(num) || !num) return '...'
    let seconds = parseInt(num);
    let minutes = parseInt(seconds / 60);
    seconds -= minutes * 60;
    const hours = parseInt(minutes / 60);
    minutes -= hours * 60;

    if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
    const result = 
        `${String(hours).padStart(2, 0)}:${minutes}:${String(seconds % 60).padStart(2, 0)}`
    return result
}
